(function () {
    'use strict';

angular.module('app.kermiTranslation', ['pascalprecht.translate'])
    .config(['$translateProvider', function ($translateProvider) {
        $translateProvider
            .registerAvailableLanguageKeys(['de', 'en', 'cs', 'fr', 'it', 'nl'], {
                'de*': 'de',
                'en*': 'en',
                'cs*': 'cs',
                'fr*': 'fr',
                'it*': 'it',
                'nl*': 'nl'
            })
            .uniformLanguageTag('bcp47')
            .useStaticFilesLoader({
                prefix: 'languages/webapp.',
                suffix: '.json'
            })
            //.useSanitizeValueStrategy('sanitize')
            .determinePreferredLanguage();

            $translateProvider.useSanitizeValueStrategy(null);

    }])

    .constant('conf_AvailableLanguages', [
        {'displayName': 'Deutsch', 'langCode': 'de', "short": 'de', 'file': 'de'},
        {'displayName': 'Čeština', 'langCode': 'cs', "short": 'cs', 'file': 'cs'},
    //  {'displayName': 'English', 'langCode': 'en', "short": 'en', 'file': 'en_gb'}
        {'displayName': 'Français','langCode': 'fr', "short": 'fr', 'file': 'fr'},
    //	{'displayName':'Italian','langCode':'IT',"short":'IT','file':_t_fr_FR},
    //	{'displayName':'Russia','langCode':'RU',"short":'RU','file':_t_fr_FR},
        {'displayName': 'Nederlands','langCode': 'nl', "short": 'nl', 'file': 'nl'},
    ])

    .service('translation', ['$rootScope', '$translate', 'API', 'conf_AvailableLanguages', 'amMoment', 'ENUM', '$q',
        function ($rootScope, $translate, API, conf_AvailableLanguages, amMoment, ENUM, $q) {
            var tr = {};
            var currentLanguage = $translate.proposedLanguage() || $translate.use();

            tr.setLanguage = function (lang) {
                var deferred = $q.defer();

                var _API = new API();
                _API.User.ChangeLanguage({'LanguageCode': lang}).$promise
                .then(function () {
                    //change language in the app
                    currentLanguage = lang;
                    $translate.use(currentLanguage);
                    //change the language on the server
                    amMoment.changeLocale(lang);
                    moment.locale(lang);

                    // send broadcast
                    $rootScope.$broadcast('$languageChanged');
                    // update EMUMs
                    ENUM.updateAll();

                    deferred.resolve(true);
                })
                .catch(function() {
                    deferred.resolve(false);
                });

                return deferred.promise;
            };

            tr.setBrowserLanguage = function (lang) {
                //change language in the app
                currentLanguage = lang;
                $translate.use(currentLanguage);

                /* Change also language for moment.js so all dates
                   and times are in correct format. */
                moment.locale(currentLanguage);
                $rootScope.$broadcast('$languageChanged');
            };

            tr.getAllLanguages = function () {
                return conf_AvailableLanguages;
            };

            tr.getCurrentLanguage = function () {
                return currentLanguage;
            };

            return tr;
        }
    ])

    .directive('languageSelection', ['$document', '$rootScope', '$timeout', 'translation',
        function ($document, $rootScope, $timeout, translation) {
            return {
                restrict: 'A',
                scope: {},
                templateUrl: 'views/head/language_selection.html',

                /* @ngInject */
                controller: function ($scope) {

                    $scope.languageMenu = false;
                    $scope.availableLanguages = translation.getAllLanguages();

                    $scope.currentLanguage = translation.getCurrentLanguage();

                    $scope.changeLanguage = function (lang) {
                        translation.setLanguage(lang)
                        .then(function() {
                            $scope.currentLanguage = lang;
                            $scope.languageMenu = false;
                            location.reload(true);
                        });
                    };

                    $rootScope.$on('$languageChanged', function () {
                        $scope.currentLanguage = translation.getCurrentLanguage();
                    });

                    $scope.$on('showLanguageMenu', function () {
                        if (!$scope.languageMenu) {
                            $scope.languageMenu = true;
                        }
                    });

                    // close drop down on document click
                    $document.on('click', function (event) {
                       if(event.target.id !== 'languageSelection'){
                           $timeout(function() {
                               $scope.languageMenu = false;
                           }, 50);
                       }
                    });
                }
            };
        }
    ]);
})();
